<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { AttributesSectionEditorViewModel } from "@Alternatives/Attributes/Components/AttributesSectionEditor";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class AttributesSectionEditor extends Vue
    {
        get vm(): AttributesSectionEditorViewModel { return this.$props.viewModel as AttributesSectionEditorViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
        get name(): string | null { return this.vm.newName; }
        set name(val: string | null ) { this.vm.newName = val; }

        update()
        {
            this.$emit("update-section-name", this.name, this.vm.oldName);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update section name</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Name:</label>
                            <input v-model.trim="name" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="update" type="button" class="btn btn-primary">Update</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>